<template>
  <div>
    <el-form :model="form" :inline="true" size="mini" class="form-wrapper">
      <el-form-item style="float: right;">
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button type="warning" @click="onReset">重置</el-button>
        <el-button type="blue" @click="onExport">导出</el-button>
      </el-form-item>
      <el-form-item label="产品编码">
        <el-input v-model.trim="form.productCode"></el-input>
      </el-form-item>
      <el-form-item label="产品名称">
        <el-input v-model.trim="form.productName"></el-input>
      </el-form-item>
      <el-form-item label="所属店铺">
        <el-select v-model="form.storeId">
          <el-option label="全部" value=""/>
          <el-option
            v-for="(item, index) in shopOptions"
            :key="index"
            :label="item.shopName"
            :value="item.shopId">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  model: {
    prop: 'formData',
    event: 'input'
  },
  props: ['formData', 'shopOptions','propList','exportData'],
  data() {
    return {
      collapse: false,
      form: {}
    }
  },
  watch: {
    formData: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    onSearch(data) {
      this.$emit('search', this.form, data)
    },
    onReset() {
      this.form = {};
      this.$nextTick(_=>{
        this.onSearch(1);
      })
    },
    // 导出 --新接口
    // 导出 --新接口
    onExport() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-new",
          paramMap: this.formData,
          reportName: "newProductAExport",
        },
        columnDTOs: [],
      };
      let labels = this.propList.map((v) => v.label);
      let props = this.propList.map((v) => v.prop);
      props.forEach((prop, index) => {
        params.columnDTOs.push({
          columnName: labels[index],
          parentColumnName: null,
          fieldName: prop,
          fieldType: "string",
          columnFormat: null,
        });
      });
      // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter(
        (v) => v.columnName !== "图片"
      );
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
          loading.close()
        } else {
          this.$message.error(res.message);
        }
      });
    }
  },
}
</script>
<style lang="stylus" scoped>
  .form-wrapper
    width 100%
    margin-top 15px
    >>> .el-form-item
      margin-bottom 10px

    >>> .el-input
      width 110px !important
    
    >>> .el-date-editor,>>> .el-date-editor input
      width 120px !important
    >>> .el-date-editor input
      padding-right 10px

    >>> .el-button--blue
      color #ffffff
      background-color #00A8E8
      border-color #00A8E8
</style>